var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M0,387.466c1.077,20.215,17.807,36.277,38.292,36.277h435.359c21.18,0,38.349-17.169,38.349-38.349 v-73.479H0V387.466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M473.651,88.257H38.292c-20.485,0-37.215,16.062-38.292,36.277v75.552h512v-73.479 C512,105.427,494.831,88.257,473.651,88.257z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 200.089,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 111.83
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M268.071,292.611c-19.812,0-35.885-16.072-35.885-35.903c0-19.795,16.072-35.903,35.885-35.903 c7.372,0,14.17,2.267,19.835,6.104c0.867,0.588,1.857-0.553,1.131-1.308c-8.467-8.802-20.45-14.173-33.736-13.72 c-22.826,0.779-41.723,19.08-43.182,41.873c-1.671,26.107,19.001,47.803,44.74,47.803c12.678,0,24.072-5.3,32.21-13.775 c0.718-0.748-0.274-1.872-1.132-1.289C282.265,290.341,275.456,292.611,268.071,292.611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M299.486,234.608l3.723,10.468l10.035-4.77c0.756-0.36,1.545,0.429,1.185,1.185l-4.771,10.035 l10.468,3.723c0.789,0.28,0.789,1.396,0,1.676l-10.468,3.723l4.771,10.035c0.36,0.756-0.429,1.545-1.185,1.185l-10.035-4.77 l-3.723,10.469c-0.28,0.789-1.396,0.789-1.676,0l-3.723-10.468l-10.035,4.77c-0.756,0.36-1.545-0.429-1.185-1.185l4.77-10.035 l-10.468-3.723c-0.789-0.28-0.789-1.396,0-1.676l10.468-3.723l-4.77-10.035c-0.36-0.756,0.429-1.545,1.185-1.185l10.035,4.77 l3.723-10.468C298.091,233.821,299.206,233.821,299.486,234.608z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAz);
export default __webpack_public_path__ + "static/media/az.a8c2f764350a4ff4769ef1a688b7c595.svg";
export { ForwardRef as ReactComponent };